import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPages = () => {
    const pages = [];

    if (currentPage > 3) {
      pages.push(1);
      if (currentPage > 4) {
        pages.push('...');
      }
    }

    for (let i = Math.max(2, currentPage - 2); i <= Math.min(totalPages - 1, currentPage + 2); i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) {
      if (currentPage < totalPages - 3) {
        pages.push('...');
      }
      pages.push(totalPages);
    }

    return pages;
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="tw-flex tw-items-center tw-gap-2 new-pod-ui">
      <button
        className={`tw-py-1 tw-px-3 tw-rounded-md tw-border-solid tw-border tw-border-gray-50 ${currentPage === 1 ? 'tw-bg-gray-300 tw-cursor-not-allowed' : 'tw-bg-secondary tw-text-white hover:tw-bg-secondary'}`}
        onClick={handlePrevClick}
        disabled={currentPage === 1}
      >
        {'<'}
      </button>

      {getPages().map((page, index) =>
        typeof page === 'number' ? (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={`tw-py-1 tw-px-3 tw-rounded-md tw-border-solid tw-border tw-border-gray-50 ${page === currentPage ? 'tw-bg-secondary tw-text-white' : 'tw-bg-gray-200 hover:tw-bg-gray-300'}`}
          >
            {page}
          </button>
        ) : (
          <span key={index} className="tw-px-3 tw-py-1">
            {page}
          </span>
        )
      )}

      <button
        className={`tw-py-1 tw-px-3 tw-rounded-md tw-border-solid tw-border tw-border-gray-50 ${currentPage === totalPages ? 'tw-bg-gray-300 tw-cursor-not-allowed' : 'tw-bg-secondary tw-text-white hover:tw-bg-secondary'}`}
        onClick={handleNextClick}
        disabled={currentPage === totalPages}
      >
        {'>'}
      </button>
    </div>
  );
};

export default React.memo(Pagination);
